const ENVS = {
  internal: {
    development: 'https://aosp-operation-frontend-internal.beta.saybot.net',
    beta: 'https://aosp-operation-frontend-internal.beta.saybot.net',
    staging: 'https://aosp-operation-frontend-internal.staging.saybot.net',
    production: 'https://aosp.alo7.com',
  },
  external: {
    development: 'https://aosp-operation-frontend-external.beta.saybot.net',
    beta: 'https://aosp-operation-frontend-external.beta.saybot.net',
    staging: 'https://aosp-operation-frontend-external.staging.saybot.net',
    production: 'https://school.alo7.com',
  },
};

export default () => {
  const { referer, platform } = alo7Account;
  const { debug } = nx.hashlize();
  if (debug) return null;
  if (nx.isInIframe() && referer === 'aosp') return nx.$message.post('token-expired', true);
  return location.replace(ENVS[platform][process.env.NODE_ENV]);
};
